import React from 'react';
import { makeStyles, fade } from '@material-ui/core/styles';
import { Button, Card, CardContent, CardActionArea, CardActions, Icon, Tooltip, IconButton } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
	root: {
		cursor: 'pointer'
	},
	pos: {
		marginBottom: 12
	},
	imageIcon: {
		background: fade(theme.palette.secondary.main, 0.8),
		'&:hover': {
			background: fade(theme.palette.secondary.main, 1)
		}
	}
}));

function FilePickerDirectoryItem(props) {
	const classes = useStyles();

	return (
		<Card className={classes.root} variant="outlined">
			<CardActionArea className="file-item" onClick={() => props.onChangeDirectory()}>
				<CardContent className="p-0">
					<div className="w-full flex items-center justify-center h-192 border-b">
						<Icon style={{ fontSize: '6rem' }}>{props.item ? 'folder_open' : 'keyboard_backspace'}</Icon>
						{props.selectable ? (
							<Tooltip title="Kiválasztás">
								<IconButton
									className={clsx(classes.imageIcon, 'absolute top-12 left-12')}
									onClick={e => {
										props.onSelectDirectory();
										e.preventDefault();
									}}
								>
									<Icon fontSize="small">present_to_all</Icon>
								</IconButton>
							</Tooltip>
						) : null}
					</div>
				</CardContent>
			</CardActionArea>
			<CardActions>
				<Button size="small" className="w-full text-center file-item" onClick={() => props.onChangeDirectory()}>
					{props.item ? <div dangerouslySetInnerHTML={{ __html: props.item.fileName.replaceAll('_', '_<wbr>') }} /> : 'Vissza...'}
				</Button>
			</CardActions>
		</Card>
	);
}

export default FilePickerDirectoryItem;
